import { createFileRoute } from '@tanstack/react-router';
import ExportRequestsTemplate from '@/features/agent/export_requests/templates/ExportRequestsTemplate';

export const Route = createFileRoute('/agent/export_requests/')({
  component: RouteComponent,
  staticData: { title: 'データ出力' },
});

function RouteComponent() {
  return (
    <div>
      <ExportRequestsTemplate />
    </div>
  );
}
